// extracted by mini-css-extract-plugin
export default {"Title":"RoleElement_Title__+GR-N","Permissions":"RoleElement_Permissions__D4015","Checkboxes":"RoleElement_Checkboxes__3F6hF"};